export const casinoLink: string = 'https://lvbet.com/casino/{lang}/';
export const liveCasinoLink: string = 'https://lvbet.com/casino/{lang}/live-casino/';

export const tgCasinoLink: string = 'https://lvbettg.com/casino/{lang}/';
export const tgLiveCasinoLink: string = 'https://lvbettg.com/casino/{lang}/live-casino/';
